import { render, staticRenderFns } from "./expandable-item.vue?vue&type=template&id=664ccdf0&"
import script from "./expandable-item.vue?vue&type=script&lang=js&"
export * from "./expandable-item.vue?vue&type=script&lang=js&"
import style0 from "./expandable-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports